module.exports = __webpack_public_path__ + "static/media/plantC.928cbbd6.png";